import React, { useContext } from 'react';

import I18nContext from '../../../contexts/I18nContext';

interface AvatarProps {
  pictureUrl: string;
  firstName: string;
  lastName: string;
}

export const Avatar = React.forwardRef<
  HTMLButtonElement,
  JSX.IntrinsicElements['button'] & AvatarProps
>(function TooltipTrigger(
  { pictureUrl, firstName, lastName, ...props },
  propRef
) {
  const fullName = `${firstName} ${lastName}`;
  const { t } = useContext(I18nContext);

  const initials =
    firstName && lastName
      ? `${firstName.charAt(0)} ${lastName.charAt(0)}`
      : '__';
  return (
    <button
      type="button"
      className="au-flex au-cursor-pointer au-items-center"
      ref={propRef}
      {...props}
    >
      <div className="au-flex au-items-center">
        <span
          aria-label={t('avatarFor', { fullName, ns: 'common' })}
          className="au-bg-red-coral au-text-c14 au-text-gray-3c au-w-c32 au-h-c32 au-leading-8 au-block au-relative au-m-0  au-text-center au-rounded-full au-overflow-hidden  au-bg-clip-padding"
          role="img"
        >
          {pictureUrl && (
            <img
              src={pictureUrl}
              alt={t('avatarFor', { fullName, ns: 'common' })}
              className=" au-w-32px au-h-32px au-block "
            />
          )}
          <span className="au-cursor-pointer" aria-hidden="true">
            {initials}
          </span>
        </span>
      </div>
    </button>
  );
});
